import React, { useEffect } from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as CancelIcon } from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import CalendarTime from 'containers/CalendarTime/CalendarTimeContainer';
import ContactDetails from 'containers/Contacts/ContactDetails';
import CallButtons from 'containers/CallButtons/CallButtonsContainer';
import classes from './CalendarMeetingView.module.scss';

const CalendarMeetingView = (props) => {
  const { contact, title, organizer, event, extension, unselectContact, fetchContactByExtension } = props;

  const topSectionClasses = [classes.topSection, contact ? '' : classes.topSectionFull].join(' ');

  useEffect(() => {
    // fetch contact if is not loaded in store.
    if (!contact) {
      fetchContactByExtension(extension);
    }
  }, [contact, extension, fetchContactByExtension]);

  return (
    <div className={classes.container}>
      <div className={topSectionClasses}>
        <button className={classes.closeButton} onClick={unselectContact}>
          <CancelIcon data-testid="cancelIcon" />
        </button>
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.timeBar}>
          <CalendarTime event={event} timeBarClass={classes.timeBarClass} />
        </div>
        <div className={classes.meetingAdditional}>
          <FormattedMessage
            id="components.calendarMeetingView.organizer"
            defaultMessage="Organizer: {organizer}"
            values={{
              organizer
            }}
          />
        </div>
        <CallButtons extension={extension} bigButton />
      </div>
      {contact && (
        <div className={classes.detailsContainer}>
          <ContactDetails contact={contact} />
        </div>
      )}
    </div>
  );
};

CalendarMeetingView.propTypes = {
  contact: PT.object,
  extension: PT.string,
  title: PT.string,
  organizer: PT.string,
  event: PT.object,
  unselectContact: PT.func
};

export default CalendarMeetingView;
